import React, { useState , useEffect } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ROw, Col, Input, Label } from 'reactstrap';
import CreatableSelect from 'react-select/creatable';
//import images
import avatar1 from '../../../assets/images/users/avatar-1.jpg';
import { useDispatch } from 'react-redux';
import { Create_New_Bot, Get_Create_Bot_Group_List, Get_Create_Bot_Model_List, Get_Plan_Allowed_Features } from '../../../slices/thunks';
import { useSelector } from 'react-redux';
import { create_bot_reset, create_set_bot_description, create_set_bot_Group, create_set_bot_Knowledge_Base, create_set_bot_name, create_set_Embedding_Model, create_set_Model, create_set_SQL_Model, set_bot_Category, set_bot_logo } from '../../../slices/Create_New_bot/reducer';
import { useNavigate } from 'react-router-dom';
import Loader from '../Loader';
import { open_select_db_modal } from '../../../slices/Select_DB_Modal/reducer';
import { get_Bot_Categories } from '../../../helpers/fakebackend_helper';
import { fileToBase64 } from '../../../slices/layouts/utils';
import { set_open_create_new_bot } from '../../../slices/groups/reducer';
import Create_New_Group_modal from './Create_New_Group_modal';
import PlanDetailsModal from '../PlanDetailsModal';
import { set_open_feature_not_available_modal } from '../../../slices/Error_Modal/reducer';

const CreateNewBot = ({group_id}) => {
   // modal_grid Example
   const {  Open_create_new_bot  }  = useSelector((state)=>state.Group_List)
   const {plan_features_available} =  useSelector((state)=>state.Plans)
   const [DbLink_allowed, setDbLink_allowed] = useState(false)
   const [modal_grid, setmodal_grid] = useState(false);
   const [bot_category_list, setbot_category_list] = useState([])
   const [user_avatar, setuser_avatar] = useState(null)
   const [user_avatar_file, setuser_avatar_file] = useState(null)
    const {user_guide_open_state} = useSelector((state)=> state.Group_List)
   const navigate = useNavigate()
   
   const dispatch = useDispatch();
   function tog_grid() {
       setmodal_grid(!modal_grid);
       dispatch(set_open_create_new_bot(!modal_grid))
       if(!modal_grid){
        dispatch(create_set_bot_Group(""))
       }
   }
    const { loading , Bot_Name , Group , Model , Embedding_Model ,Bot_Description , Knowledge_base_type , Group_List , Model_List , Embedding_Model_List , Instruction , Sample_Question , Bot_Logo , SQL_Model  }  = useSelector((state)=>state.Create_Bot)
    const [form_error, setform_error] = useState({
        error : false,
        message : ""
    } )



    useEffect(() => {
      
        dispatch(create_bot_reset())
        dispatch(Get_Create_Bot_Model_List())
        dispatch(Get_Create_Bot_Group_List())
        dispatch(Get_Plan_Allowed_Features())

        if(group_id){
            
            dispatch(create_set_bot_Group(group_id))
        }


    }, [])


    useEffect(() => {
       
        plan_features_available?.map((ele)=>{
            if( ele.Allowed_To_User  && ele.Bot_type === 'DbLink'){
                setDbLink_allowed(true)
            }  
        })

    }, [plan_features_available])
    


           //Get Bot Categoty
  useEffect(() => {
    get_Bot_Categories().then((response) => {
         const category_options_temp = response.map((ele)=>{
            const {BOT_Category} = ele;
            return   { value: BOT_Category, label: BOT_Category }
         })

         setbot_category_list(category_options_temp)
    })
  }, [])
      


    const Radio_on_Checked = (e)=>{
    
        dispatch(create_set_bot_Knowledge_Base(e.target.value))
        
    }




    useEffect(() => {
        // console.log("Affecting this ");
        
        if(Open_create_new_bot && !user_guide_open_state){
        setmodal_grid(Open_create_new_bot)
        }

    },[Open_create_new_bot, user_guide_open_state])


    // Set Default Model .






  return (


    <>
      <Button onClick={() => tog_grid()}>Create New Bot</Button>
      {/* Grids in Modals */}

      <Modal
                isOpen={modal_grid}
                toggle={() => {
                    tog_grid();
                }}
            >
                <ModalHeader className="modal-title" toggle={() => {
                    tog_grid();
                }}>
                    Create A New Bot

                </ModalHeader>

                <ModalBody>
                    { loading ?<Loader/> : <form 

     
                    onSubmit={(e)=>{
                        
                        
                       e.preventDefault();

                       if(!DbLink_allowed && Knowledge_base_type=='DBLink' ){
                        dispatch(set_open_feature_not_available_modal(true))
                        return
                       }

                       if(Knowledge_base_type==='General'){

                      

                       

                        dispatch(
                          Create_New_Bot(
                            {
                            Group_ID: Group,
                            title: Bot_Name,
                            description:Bot_Description,
                            model: Model,
                            type: Knowledge_base_type,
                            bot_logo:user_avatar_file,
                            Embedding_Model: Embedding_Model,
                          }
                          ,navigate)
                        );

                       }
                       else if(Knowledge_base_type==='DBLink'){
                       
                        dispatch(open_select_db_modal())

                       }
                    
                    }}
                    
                   >
                        <div className="row g-3">
                            <Col lg={7}>
                                <div className='cnbn'>
                                    <label htmlFor="botname" className="form-label">Bot Name *</label>
                                    <Input required={true} value={Bot_Name} onChange={(e)=>{{
                                        dispatch(create_set_bot_name(e.target.value))
                                    }}}  type="text" className="form-control" id="firstName" placeholder="" />
                                </div>
                            </Col>
                            <Col lg={5}>
                            <div className="text-center">
                                        <div className="profile-user position-relative d-inline-block mx-auto  mb-4">
                                            <img src={user_avatar||avatar1}
                                                className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                                                alt="user-profile" />
                                            <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                                                <Input name='profile_image'  id="profile-img-file-input" type="file"
                                                    className="profile-img-file-input"
                                                    accept=".jpg,.jpeg,.png"
                                                     
                                                    // onChange={(e)=>{
                                                    //     console.log("Comming to profile");
                                                        
                                                    //     setuser_avatar(URL.createObjectURL(e.target.files[0]))
                                                    //     setuser_avatar_file(e.target.files[0])
                                                    //     dispatch(set_bot_logo(e.target.files[0]))
                                                    // }}
                                                    
                                                    onChange={async (e) => {
                                                        const file = e.target.files[0];
                                                        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png'];

                                                        if (file && allowedTypes.includes(file.type)) {
                                                            // console.log("File accepted for profile");
                                                            setuser_avatar(URL.createObjectURL(file));
                                                            setuser_avatar_file(file);
                                                            const blob=  await fileToBase64(file)
                                                            const blobString = JSON.stringify(blob);

                                                            dispatch(set_bot_logo(blobString));
                                                        } else {
                                                            alert('Please upload a valid JPG or PNG file.');
                                                            e.target.value = null; // Reset the input
                                                        }
                                                    }}

                                                    />
                                                <Label htmlFor="profile-img-file-input"
                                                    className="profile-photo-edit avatar-xs">
                                                    <span className="avatar-title rounded-circle bg-light text-body">
                                                        <i className="ri-camera-fill"></i>
                                                    </span>
                                                </Label>
                                            </div>
                                        </div>
                                    </div>
                            </Col>
                    
                            
                            <Col className="mt-0" lg={6}>
                                <label  htmlFor="group" className="form-label">Group *</label>
                                {/* <select required={true}  onChange={(e)=>{{
                                        dispatch(create_set_bot_Group(e.target.value))
                                    }}}   className="form-select" aria-label=".form-select-sm example">
                                 <option  ></option>
                                    {
                                        Group_List.map((ele,i)=>{
                                           
                                            return       <option selected={ele.Group_ID === Group} key={i} value={ele.Group_ID}>{ele.Group_Name}</option>
                                        })
                                    }
                                
                                </select> */}
                                {Group_List && Group_List.length > 0 ? (
                                    <select 
                                        required 
                                        onChange={(e) => dispatch(create_set_bot_Group(e.target.value))}
                                        className="form-select" 
                                        aria-label=".form-select-sm example"
                                        value={Group}
                                    >
                                        <option value="" disabled selected>Select a group</option>
                                        {Group_List.map((ele, i) => (
                                            <option 
                                                key={i} 
                                                value={ele.Group_ID}
                                            >
                                                {ele.Group_Name}
                                            </option>
                                        ))}
                                    </select>
                                ) : (
                                    <Create_New_Group_modal />
                                )}
                            </Col>
                            {/* <Col className="mt-0" lg={6} >
                            <CreatableSelect onChange={(value)=>{
                                if(value){

                                    dispatch(set_bot_Category(value))
                                }else{ 
                                    dispatch(set_bot_Category(""))
                                }
                            }} required={true} options={bot_category_list} />
                            </Col> */}
                            {/* <Col className="mt-0" lg={6}>
                                <label htmlFor="llm_model" className="form-label">Model *</label> */}
                                {/* <select   onChange={(e)=>{
                                        dispatch(create_set_Model(e.target.value))}}   
                                    className="form-select" aria-label=".form-select-sm example">
                                  
                                    {
                                        Model_List.map((ele, i)=>{
                                            return <option selected={ele.ModelVersion===Model} value={ele.ModelVersion} key={ele.ModelID} >{ele.ModelVersion}</option>
                                        })
                                    }
                                    
                                </select> */}
                                {/* <select
                                    onChange={(e) => dispatch(create_set_Model(e.target.value))}
                                    className="form-select"
                                    aria-label=".form-select-sm example"
                                    >
                                    {Object.entries(
                                        Model_List.reduce((acc, ele) => {
                                        if (!acc[ele.Provider]) acc[ele.Provider] = [];
                                        acc[ele.Provider].push(ele);
                                        return acc;
                                        }, {})
                                    ).map(([provider, models]) => (
                                        <optgroup label={provider} key={provider}>
                                        {models.map((ele) => (
                                            <option 
                                            selected={ele.ModelVersion === Model} 
                                            value={ele.ModelVersion} 
                                            key={ele.ModelID}
                                            >
                                            {ele.ModelVersion}
                                            </option>
                                        ))}
                                        </optgroup>
                                    ))}
                                </select> */}
                            {/* </Col> */}
                            {(Knowledge_base_type === "General" || Knowledge_base_type === "DBLink") && (
                                <>
                                    <Col className="mt-0" lg={6}>
                                    <label htmlFor="llm_model" className="form-label">Resposne Model *</label>
                                    <select
                                        onChange={(e) => dispatch(create_set_Model(e.target.value))}
                                        className="form-select"
                                        aria-label=".form-select-sm example"
                                    >
                                        {Object.entries(
                                        Model_List.reduce((acc, ele) => {
                                            if (!acc[ele.Provider]) acc[ele.Provider] = [];
                                            acc[ele.Provider].push(ele);
                                            return acc;
                                        }, {})
                                        ).map(([provider, models]) => (
                                        <optgroup label={provider} key={provider}>
                                            {models.map((ele) => (
                                            <option 
                                                selected={ele.ModelVersion === Model} 
                                                value={ele.ModelVersion} 
                                                key={ele.ModelID}
                                            >
                                                {ele.ModelVersion}
                                            </option>
                                            ))}
                                        </optgroup>
                                        ))}
                                    </select>
                                    </Col>

                                    {Knowledge_base_type === "DBLink" && (
                                    <Col className="mt-1" lg={12}>
                                        <label htmlFor="llm_model" className="form-label">SQL Model *</label>
                                        <select
                                        onChange={(e) => dispatch(create_set_SQL_Model(e.target.value))}
                                        className="form-select"
                                        aria-label=".form-select-sm example"
                                        >
                                        {Object.entries(
                                            Model_List.reduce((acc, ele) => {
                                            if (!acc[ele.Provider]) acc[ele.Provider] = [];
                                            acc[ele.Provider].push(ele);
                                            return acc;
                                            }, {})
                                        ).map(([provider, models]) => (
                                            <optgroup label={provider} key={provider}>
                                            {models.map((ele) => (
                                                <option 
                                                selected={ele.ModelVersion === SQL_Model} 
                                                value={ele.ModelVersion} 
                                                key={ele.ModelID}
                                                >
                                                {ele.ModelVersion}
                                                </option>
                                            ))}
                                            </optgroup>
                                        ))}
                                        </select>
                                    </Col>
                                    )}
                                </>
                                )}
                                <Col className="mt-4" lg={12}>
                                    <label htmlFor="llm_model" className="form-label">Vector Embedding Models</label>
                                    <select
                                        onChange={(e) => dispatch(create_set_Embedding_Model(e.target.value))}
                                        className="form-select"
                                        aria-label=".form-select-sm example"
                                    >
                                        {Object.entries(
                                        Embedding_Model_List.reduce((acc, ele) => {
                                            if (!acc[ele.EmdProvider]) acc[ele.EmdProvider] = [];
                                            acc[ele.EmdProvider].push(ele);
                                            return acc;
                                        }, {})
                                        ).map(([EmdProvider, models]) => (
                                        <optgroup label={EmdProvider} key={EmdProvider}>
                                            {models.map((ele) => (
                                            <option 
                                                selected={ele.EmdModelVersion === Embedding_Model} 
                                                value={ele.EmdModelVersion} 
                                                key={ele.EmdModelID}
                                            >
                                                {ele.EmdModelVersion}
                                            </option>
                                            ))}
                                        </optgroup>
                                        ))}
                                    </select>
                                    </Col>

                            <Col lg={12 }>
                            <div>
                                <label htmlFor="description" className="form-label">Bot Description </label>
                                <textarea required={false} value={Bot_Description} onChange={(e)=>{{
                                        dispatch(create_set_bot_description(e.target.value))
                                    }}} className="form-control" id="botdescription" rows="5"></textarea>
                            </div>
                            </Col>
                            <Col lg={12}>
                                <label className="form-label">Knowledge base (Type) *</label>
                                <div>
                                    <div className="form-check">
                                        <Input required value="General" onChange={Radio_on_Checked} checked={Knowledge_base_type==='General'} className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1"  />
                                        <label  className="form-check-label" htmlFor="inlineRadio1">General/File/Text/Website/Q&A</label>
                                    </div>
                                    { <div className="form-check mt-15">
                                        <Input  value="DBLink" onChange={Radio_on_Checked} checked={Knowledge_base_type==='DBLink'} className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2"  />
                                        <label  className="form-check-label" htmlFor="inlineRadio2">Link Database</label>
                                    </div>}
                                    {/* <div className="form-check mt-15">
                                        <Input value="BasicBot" onChange={Radio_on_Checked} className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2"  />
                                        <label  className="form-check-label" htmlFor="inlineRadio2">Basic Bot</label>
                                    </div> */}
                                </div>
                                <PlanDetailsModal />
                            </Col>                            
                            <Col lg={12}>
                                <div className="hstack gap-2 justify-content-center">
                                    <Button color="light" onClick={() => setmodal_grid(false)}>Cancel</Button>
                                    <Button  type="submit" 
                                    // onClick={()=>{
                                    //         if(Knowledge_base_type==='Combine'){

                      

                       

                                    //             dispatch(
                                    //               Create_New_Bot({
                                    //                 Group_ID: Group,
                                    //                 title: Bot_Name,
                                    //                 description:Bot_Description,
                                    //                 model: Model,
                                    //                 type: Knowledge_base_type,
                                    //               },navigate)
                                    //             );
                        
                                    //            }
                                    //            else if(Knowledge_base_type==='DBLink'){

                                    //             dispatch(open_select_db_modal())
                        
                                    //            }
                                    // }} 
                                    
                                    
                                    >Next</Button>
                                </div>
                            </Col>
                     
                        </div>
                    </form>}
                </ModalBody>
            </Modal>

    </>
  )
}

export default CreateNewBot
